"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function variationName(name, value) {
  return `${name}${value.charAt(0).toUpperCase()}${value.slice(1)}`;
}
function sanitizeCustomProperties(styles) {
  const nonNullValues = Object.entries(styles).filter(([, value]) => value != null);
  return nonNullValues.length ? Object.fromEntries(nonNullValues) : void 0;
}
function getComponentToken(componentName, componentProp, value) {
  return value ? {
    [`--ezui-c-${tokenSafeKebabCase(componentName)}-${tokenSafeKebabCase(componentProp)}`]: value
  } : {};
}
function getComponentDesignToken(componentName, componentProp, tokenSubgroup, token) {
  return getComponentToken(componentName, componentProp, token ? `var(--ezui-${tokenSafeKebabCase(tokenSubgroup)}-${tokenSafeKebabCase(token)})` : void 0);
}
function getComponentThemeToken(componentName, componentProp, tokenSubgroup, token) {
  return getComponentToken(componentName, componentProp, token ? `var(--ezui-t-${tokenSafeKebabCase(tokenSubgroup)}-${tokenSafeKebabCase(token)})` : void 0);
}
function getResponsiveDesignToken(componentName, componentProp, tokenSubgroup, responsiveProp) {
  if (!responsiveProp) {
    return {};
  }
  if (typeof responsiveProp === "string") {
    return getComponentToken(componentName, `${componentProp}-xs`, `var(--ezui-${tokenSafeKebabCase(tokenSubgroup)}-${tokenSafeKebabCase(responsiveProp)})`);
  }
  return Object.fromEntries(Object.entries(responsiveProp).map(([breakpointAlias, aliasOrScale]) => {
    const [tokenEntry] = Object.entries(getComponentToken(componentName, `${componentProp}-${breakpointAlias}`, aliasOrScale ? `var(--ezui-${tokenSafeKebabCase(tokenSubgroup)}-${tokenSafeKebabCase(aliasOrScale)})` : void 0));
    return tokenEntry;
  }).filter((e) => Boolean(e)));
}
function getResponsiveValue(componentName, componentProp, responsiveValue) {
  if (!responsiveValue) {
    return {};
  }
  if (typeof responsiveValue === "string" || typeof responsiveValue === "number") {
    return getComponentToken(componentName, `${componentProp}-xs`, addPxUnitToNumber(responsiveValue));
  }
  return Object.fromEntries(Object.entries(responsiveValue).map(([breakpointAlias, responsiveValue2]) => {
    const [tokenEntry] = Object.entries(getComponentToken(componentName, `${componentProp}-${breakpointAlias}`, addPxUnitToNumber(responsiveValue2)));
    return tokenEntry;
  }).filter((e) => Boolean(e)));
}
function pxToRem(px) {
  return parseInt(String(px), 10) / 16;
}
function addPxUnitToNumber(px) {
  return typeof px === "number" ? `${px}px` : px;
}
function tokenSafeKebabCase(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_\.]+/g, "-").toLowerCase();
}
exports.addPxUnitToNumber = addPxUnitToNumber;
exports.classNames = classNames;
exports.getComponentDesignToken = getComponentDesignToken;
exports.getComponentThemeToken = getComponentThemeToken;
exports.getComponentToken = getComponentToken;
exports.getResponsiveDesignToken = getResponsiveDesignToken;
exports.getResponsiveValue = getResponsiveValue;
exports.pxToRem = pxToRem;
exports.sanitizeCustomProperties = sanitizeCustomProperties;
exports.tokenSafeKebabCase = tokenSafeKebabCase;
exports.variationName = variationName;
